export const SnackbarMessage = {
  TransactionSubmitted: "Transaction submitted, awaiting confirmation...",
  LockSuccess: "Lock operation successful!",
  UnlockSuccess: "Unlock reqest operation successful!",
  WithdrawSuccess: "Withdraw operation successful!",
  ApprovalSuccess: "Approval operation successful!",
  BlockDidNotReachUnlockTime:
    "Latest block has not reached unlock time yet. Try again a bit later!",
};
